import SocialAvatar from '@anm/components/SocialAvatar';
import isMobile from '@anm/helpers/is/isMobile';
import { FC } from 'react';
import { LiveStreamStatus } from 'types/stream';

import { DestinationWithStreamMeta } from '../../types';

import WebinarDestination, { WebinarDestinationProps } from './WebinarDestination';
import { AdditionalSign, DestinationsWrapper, DestinationItem, DestinationTooltip, TooltipText } from './Wrapper';
import { getDestinationParams } from './helpers';

type StreamDestinationsProps = WebinarDestinationProps & {
  state: LiveStreamStatus;
  destinations: DestinationWithStreamMeta[];
};

const StreamDestinations: FC<StreamDestinationsProps> = ({ state, webinarId, destinations, ...webinarProps }) => {
  const allDestinationLen = destinations.length;
  const mobileDestinationCount = webinarId ? 1 : 2;
  const desktopDestinationCount = webinarId ? 5 : 6;
  const MAX_DESTINATIONS = isMobile() ? mobileDestinationCount : desktopDestinationCount;

  const isAdditionalDestinations = allDestinationLen > MAX_DESTINATIONS;
  const visibleDestinations = destinations.slice(0, MAX_DESTINATIONS);

  return (
    <DestinationsWrapper>
      {webinarId && <WebinarDestination {...webinarProps} webinarId={webinarId} />}
      {visibleDestinations.map(destinationProps => (
        <DestinationTooltip
          withArrow
          variant="black"
          direction="to-top"
          key={destinationProps.id}
          renderContent={
            isMobile() || destinationProps.network === 'RTMP'
              ? undefined
              : () => <TooltipText>Click to open the scheduled event on this destination</TooltipText>
          }
        >
          <DestinationItem
            key={destinationProps.id}
            {...getDestinationParams(state, destinationProps)}
            data-omit="skipCheck"
          >
            <SocialAvatar
              {...destinationProps}
              variant="30x30"
              alt={destinationProps.title}
              avatarSrc={destinationProps.avatar}
            />
          </DestinationItem>
        </DestinationTooltip>
      ))}
      {isAdditionalDestinations && <AdditionalSign>+{allDestinationLen - MAX_DESTINATIONS}</AdditionalSign>}
    </DestinationsWrapper>
  );
};

export default StreamDestinations;
